import React, {useState, useRef} from "react"
import "./ProfileSettings.css"
import BackgroundImage from "../../assets/img/recruitment-homepage-images/background.png";
import Logo from "../../assets/img/logo/logo.png";
import LogInWithLogo from "../../assets/img/logIn/Login-fotografija.png"
import {getAuthResource, updateAuthResource} from "../service/http-service";

export const ChangePassword = () => {

    const [entity, setEntity] = useState({})
    const [confirmPassword, setConfirmPassword] = useState('')
    const [showError, setShowError] = useState(false)
    const [backError, setBackError] = useState('')

    const [viewOldPass, setViewOldPass] = useState(true)
    const [viewNewPass, setViewNewPass] = useState(true)
    const [viewConfirmedPass, setViewConfirmedPass] = useState(true)

    const PasswordRef = useRef(null);

    const goToPasswordForm = () =>
        window.scrollTo({
            top: PasswordRef.current.offsetTop,
            behavior: "auto",
        });


    return (
        <div className="container-fluid m-0 p-0 profile-settings-container">
                    <div className="row m-0 p-0 backgroundImage">
                        <img src={BackgroundImage} className="backgroundImage m-0 p-0" alt="background-image"
                             onLoad={() => goToPasswordForm()}/>
                        <div className="col-md-10 offset-md-1 col-12">
                            <div className="row m-0 p-0">
                                <div className="col-md-4 col-10 main-title">
                                    ПОДЕСУВАЊА ЗА ПРИВАТНОСТ
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mx-3 p-0">
                        <div className="col-md-10 offset-md-1 p-0 logIn-container">
                            <img src={Logo} className="logIn-logo"/>
                            <div className="logIn-content" style={{backgroundImage: `url(${LogInWithLogo})`}}>
                                <div className="profile-settings-inner">
                                    <div className="w-100 d-flex align-items-center">
                                        <input className="password-input"
                                            type={viewOldPass ? "password" : "text"}
                                            placeholder="Лозинка"
                                            onChange={(e) => {
                                                setEntity({...entity, oldPassword: e.target.value})
                                                setBackError('')
                                            }}/>
                                        <i onClick={()=> setViewOldPass(!viewOldPass)}
                                           className={viewOldPass ? "fa fa-eye" : "fa fa-eye-slash" }/>
                                    </div>
                                    <div>
                                        <input
                                            className="password-input"
                                            type={viewNewPass ? "password" : "text"}
                                            placeholder="Нова лозинка"
                                            onChange={(e) => {
                                                setEntity({...entity, password: e.target.value})
                                                setBackError('')
                                            }}/>
                                        <i onClick={()=> setViewNewPass(!viewNewPass)}
                                           className={viewNewPass ? "fa fa-eye" : "fa fa-eye-slash" }/>
                                    </div>
                                    <div>
                                        <input
                                            className="password-input"
                                            type={viewConfirmedPass ? "password" : "text"}
                                            placeholder="Потврди нова лозинка"
                                            onChange={(e) => {
                                                setConfirmPassword(e.target.value)
                                                setShowError(false)
                                                setBackError('')
                                            }}/>
                                        <i  onClick={()=> setViewConfirmedPass(!viewConfirmedPass)}
                                            className={viewConfirmedPass ? "fa fa-eye" : "fa fa-eye-slash" }/>
                                    </div>
                                  <div className="w-100 d-flex justify-content-center flex-wrap">
                                      <div className="w-100 text-center">
                                          {showError && <small>Лозинките мора да бидат исти</small>}
                                          {backError && <small>{backError}</small>}
                                      </div>
                                      <div className="profile-settings-button" onClick={(e)=> {
                                          if(entity.password !== confirmPassword){
                                              setShowError(true)
                                          } else {
                                              console.log(entity)
                                              updateAuthResource('user/change_password', entity).then(data => {
                                                  console.log(data.data);
                                                  getAuthResource('user/check_change_password').then((data) => {
                                                      sessionStorage.setItem("changePassword", JSON.stringify(data.data));
                                                      window.location.replace("/career_opportunities/profile" )
                                                  })
                                              }).catch(exception => {
                                                  console.log(exception)
                                                  setBackError(exception.response.data.message);
                                              })
                                          }}
                                      }>Промени</div>
                                  </div>
                                </div>
                            </div>
                            <div ref={PasswordRef} className="white-space"></div>
                        </div>
                    </div>
        </div>
    )
};